import React from "react";
import EmptyState from "../Patient/EmptyState";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push
    },
    dispatch
  );

@connect(
  null,
  mapDispatchToProps
)
class NotFoundPage extends React.Component {
  render() {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="my-5 shadow-small" style={{ maxWidth: "600px" }}>
          <EmptyState
            name="Error"
            icon="essential"
            description="The page you are looking for does not exist it may have been moved, or
        your account can not access."
            buttonLabel="Back"
            buttonType="default"
            onConfirm={() => this.props.push("/")}
          />
        </div>
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage/index.js